export const DIGITAIN_ENDPOINTS = Object.freeze({
  history: '/digitain/report/ticket/history',
  details: '/digitain/report/ticket/details',
  export: '/export-digitain-history',
})

export const DIGITAIN_STATUS_LABELS = {
  pending: 'status.pending',
  won: 'status.won',
  lost: 'status.lost',
  cashout: 'status.cashout',
  refund: 'status.refund',
  cancelled: 'status.null_bet',
}

export const DIGITAIN_STATUS_CLASSES = {
  pending: 'badge badge-warning p-1 rounded',
  won: 'badge badge-success p-1 rounded',
  lost: 'badge badge-danger p-1 rounded',
  cashout: 'badge badge-info p-1 rounded',
  refund: 'badge badge-secondary p-1 rounded',
  cancelled: 'badge badge-secondary p-1 rounded',
}

export const DIGITAIN_MOVEMENT_LABELS = {
  bet: 'wallet_ticket.movement_bet',
  win: 'wallet_ticket.movement_win',
  loss: 'wallet_ticket.movement_loss',
  cashout: 'wallet_ticket.movement_cashout',
  refund: 'wallet_ticket.movement_refund',
  cancel: 'wallet_ticket.movement_cancel',
  rollback: 'wallet_ticket.movement_rollback',
}

export const DIGITAIN_BET_TYPE_LABELS = {
  single: 'wallet_ticket.bet_type_single',
  combo: 'wallet_ticket.bet_type_combo',
  system: 'wallet_ticket.bet_type_system',
}

const SELECTION_STATUSES = {
  won: { i18nKey: 'status.won', variant: 'success' },
  lost: { i18nKey: 'status.lost', variant: 'danger' },
  refund: { i18nKey: 'status.return', variant: 'secondary' },
  cashout: { i18nKey: 'status.cashout', variant: 'info' },
}

export const digitainIsSettled = (status) => Boolean(status) && status !== 'pending'

export const digitainStatusClass = (status) =>
  DIGITAIN_STATUS_CLASSES[status] || 'badge badge-light p-1 rounded'

export const digitainSelectionStatus = (selection) => {
  const known = SELECTION_STATUSES[selection && selection.status]
  const raw = (selection && (selection.providerStatus || selection.status)) || ''

  if (known) return { ...known, raw }
  return raw ? { i18nKey: null, raw, variant: 'secondary' } : null
}

export const digitainPick = (selection) =>
  [selection && selection.market, selection && selection.selection].filter(Boolean).join(': ')
